/**
 * The five Core Stats.
 * RULE DCC-STAT-001 - Rules for Survival p.11; Crawlers & Customization p.13
 * Order is the official order used when rolling Stats in sequence.
 */
export const STAT_IDS = ['str', 'int', 'con', 'dex', 'cha'] as const;

export type StatId = (typeof STAT_IDS)[number];

/** A full set of the five Stat scores. */
export type StatBlock = Record<StatId, number>;

export const STAT_LABELS: Record<StatId, { full: string; abbr: string }> = {
  str: { full: 'Strength', abbr: 'Str' },
  int: { full: 'Intelligence', abbr: 'Int' },
  con: { full: 'Constitution', abbr: 'Con' },
  dex: { full: 'Dexterity', abbr: 'Dex' },
  cha: { full: 'Charisma', abbr: 'Cha' },
};

export function isStatId(value: unknown): value is StatId {
  return typeof value === 'string' && (STAT_IDS as readonly string[]).includes(value);
}

export function makeStatBlock(fill: number): StatBlock {
  return { str: fill, int: fill, con: fill, dex: fill, cha: fill };
}
